import { call, put, select, takeEvery } from 'redux-saga/effects';

import { statsConfigSelectors } from '../../config';
import { dataTableActionCreators } from '../dataTable';
import { filterActionCreators } from '../filter';
import { setToDefaultSort } from '../sagas/runReportValidation';

import actionCreators from './actionCreators';
import actionTypes from './actionTypes';
import { currentReportSagas } from './current';
import selectors from './selectors';

export function* resetReport() {
    const appliedReport = yield select(selectors.getAppliedReport);
    const currentReport = yield select(selectors.getCurrentReport);
    const { timeFrame } = currentReport;
    const config = yield select(statsConfigSelectors.getConfig);
    const defaultReport = statsConfigSelectors.getReport(config, appliedReport.reportName);
    const timeFrameReportData = statsConfigSelectors.getTimeFrameReportData(timeFrame, config.seasonData, true);
    const report = { ...defaultReport, ...timeFrameReportData };

    yield put(actionCreators.hydrateCurrentReport(report));
    yield put(dataTableActionCreators.resetPagination());
    yield call(setToDefaultSort);

    const isAppliedDiffThanDefault = Object.keys(appliedReport).some((key) => {
        const appliedVal = appliedReport[key];
        const defaultVal = report[key];
        return appliedVal !== defaultVal;
    });
    if (isAppliedDiffThanDefault) {
        yield put(filterActionCreators.resetAllFilters());
        yield put(filterActionCreators.resetAppliedFilters());
        yield put(filterActionCreators.setFiltersVisibility(false));
        yield put(actionCreators.setAppliedReport(report));
    }
}

// WATCHERS
function* watchTimeFrame() {
    yield takeEvery(actionTypes.SET_REPORT_TIME_FRAME, resetReport);
}

// DEFAULT EXPORT
export default {
    ...currentReportSagas,
    timeFrame: watchTimeFrame(),
};
